const keyEventDispatcher = (keyEvent) => {
  const keydownEvent = new KeyboardEvent('keydown', keyEvent);

  window.dispatchEvent(keydownEvent);
};

export default keyEventDispatcher;
